module.exports = __webpack_public_path__ + "img/update.e8abc9b6.png";